import React, { Component } from "react";
import TopOptions from "../components/TopOptions";
import styled from "styled-components";
import InventoryTable from "../components/InventoryTable";
import { connect } from "react-redux";
import { RoutesPath } from "../values/RoutesPath";
import { acl } from "../services/acl";

class InventoryPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: false,
        };
    }
    componentDidMount() {
        document.title = "Inventaires - Sobrus Labs";
    }

    render() {
        return (
            <Main_container className="Main_container">
                <TopOptions title="Inventaires">
                    {acl.inventory.add() && (
                        <button className="btn_bleu" data-shortcut_alias="create" onClick={() => this.props.history.push(RoutesPath.inventory.add)}>
                            Créer
                        </button>
                    )}
                </TopOptions>
                <InventoryTable {...this.props} />
            </Main_container>
        );
    }
}

const Main_container = styled.div`
    height: 100%;
`;
const mapStateToProps = (state) => {
    return {
        selected: state.selcted,
    };
};
export default connect(mapStateToProps)(InventoryPage);
